"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_STATUSES = exports.TENANT_STATUSES = void 0;
exports.isSiteStatus = isSiteStatus;
exports.subdomainSlug = subdomainSlug;
exports.TENANT_STATUSES = ['active', 'suspended', 'terminated'];
exports.SITE_STATUSES = ['provisioning', 'live', 'suspended', 'archived'];
/**
 * 站点上下文。
 *
 * 这是 Host 解析的产物，也是渲染层唯一允许依赖的"身份"对象。
 * 刻意不把 tenant.id 单独散着传：渲染层拿到 SiteContext 就有全部信息，
 * 拿不到就什么也查不了，避免出现"页面组件自己拼 tenantId 去查数据"这种越权入口。
 */
/**
 * 站点生命周期状态（与 `sites.status` 的 check 约束逐字一致）。
 *
 * 控制台必须能看见这个值，否则"站点被降档收缩暂停"在客户眼里就是
 * "我的网站凭空 404 了，而且列表里看起来一切正常"。
 */
function isSiteStatus(v) {
    return typeof v === 'string' && exports.SITE_STATUSES.includes(v);
}
/**
 * 从 Host 反推租户 slug（用于 `{slug}.platform.com` 这类平台子域）。
 * 自有域名不走这里——它们必须查 host 映射表，绝不能靠字符串解析猜租户，
 * 否则一个精心构造的 Host 头就能读到别人的站点。
 */
function subdomainSlug(host, platformDomain) {
    const h = host.toLowerCase();
    const base = platformDomain.toLowerCase();
    if (!h.endsWith(`.${base}`))
        return null;
    const sub = h.slice(0, -(base.length + 1));
    if (!sub || sub.includes('.'))
        return null;
    if (sub === 'www' || sub === 'api' || sub === 'admin')
        return null;
    return sub;
}
//# sourceMappingURL=site.js.map